import {
  Language,
  COUNTRIES,
  FuelEfficiencyUnit,
  DateFormat,
  CurrencyType,
  HOUR_FORMATS,
} from '@upstart/harmony/lib/constants';

const DealerLocalisationDefaults = {
  [COUNTRIES.US]: {
    supportedLanguages: [Language.EN_US, Language.ES_MX],
    defaultLanguage: Language.EN_US,
    dateFormat: DateFormat.MM_DD_YYYY,
    fuelEfficiencyUnit: FuelEfficiencyUnit.MPG,
    hourFormat: HOUR_FORMATS.HF_12,
    currency: CurrencyType.USD,
  },
  [COUNTRIES.CA]: {
    supportedLanguages: [Language.EN_CA],
    defaultLanguage: Language.EN_CA,
    dateFormat: DateFormat.DD_MM_YYYY,
    fuelEfficiencyUnit: FuelEfficiencyUnit.L_100KM,
    hourFormat: HOUR_FORMATS.HF_12,
    currency: CurrencyType.CAD,
  },
};

export const HOUR_FORMAT_LABELS = {
  [HOUR_FORMATS.HF_24]: '24 Hour - 19:15',
  [HOUR_FORMATS.HF_12]: '12 Hour - 7:15pm',
};

export const SUPPORTED_LANGUAGE_LABELS = {
  [Language.EN_US]: 'American English en-US',
  [Language.EN_CA]: 'Canadian English en-CA',
  [Language.ES_MX]: 'Spanish es-MX',
};

export const COUNTRIES_LABELS = {
  [COUNTRIES.US]: 'United States',
  [COUNTRIES.CA]: 'Canada',
};

export const UNIT_LABELS = {
  [FuelEfficiencyUnit.L_100KM]: 'Metric - kilometers',
  [FuelEfficiencyUnit.MPG]: 'Imperial - miles',
};

export default DealerLocalisationDefaults;
